import React from "react";
import RateDriverSection from "./section";

const RateDriver = () => {
  return (
    <React.Fragment>
      <RateDriverSection />
    </React.Fragment>
  );
};

export default RateDriver;
